import { ref, computed } from 'vue';

const endpoint = '/configuracoes/empresa/boletos-operacionais';
export function useBoletosModuloControl(api, podeAlterarModulo) {
  const estado = ref(null);
  const metadata = ref(null);
  const busy = ref(false);
  const erro = ref('');
  const sucesso = ref('');
  const alvo = ref(null);
  const confirmacao = ref('');
  const frase = computed(() => alvo.value === null ? '' :
    metadata.value?.confirmacoes?.[alvo.value ? 'habilitar' : 'desabilitar'] || '');
  const podeConfirmar = computed(() => podeAlterarModulo() && !busy.value &&
    typeof estado.value === 'boolean' && typeof alvo.value === 'boolean' &&
    frase.value.length > 0 && confirmacao.value === frase.value);

  function fechar() { alvo.value = null; confirmacao.value = ''; }
  async function consultar() {
    estado.value = null;
    metadata.value = null;
    const { data: capability } = await api.get('/financeiro/cobrancas/capabilities');
    if (typeof capability?.boletosOperacionais !== 'boolean') throw new Error('Resposta incompleta');
    if (podeAlterarModulo()) {
      const { data } = await api.get(endpoint);
      if (typeof data?.boletos_operacionais !== 'boolean' ||
          typeof data?.confirmacoes?.habilitar !== 'string' || !data.confirmacoes.habilitar.trim() ||
          typeof data?.confirmacoes?.desabilitar !== 'string' || !data.confirmacoes.desabilitar.trim() ||
          data.boletos_operacionais !== capability.boletosOperacionais) throw new Error('Estado não confirmado');
      metadata.value = data;
    }
    estado.value = capability.boletosOperacionais;
  }
  async function carregar() {
    if (busy.value) return;
    busy.value = true;
    erro.value = ''; sucesso.value = ''; fechar();
    try { await consultar(); }
    catch { estado.value = null; metadata.value = null;
      erro.value = 'Não foi possível confirmar o estado do módulo. Atualize os dados antes de continuar.'; }
    finally { busy.value = false; }
  }
  function solicitar() {
    if (!podeAlterarModulo() || busy.value || typeof estado.value !== 'boolean' || !metadata.value) return;
    alvo.value = !estado.value; confirmacao.value = ''; erro.value = ''; sucesso.value = '';
  }
  async function salvar() {
    if (!podeConfirmar.value) return;
    const desejado = alvo.value;
    const payload = { habilitado: desejado, estado_anterior: estado.value, confirmacao: confirmacao.value };
    busy.value = true; erro.value = ''; sucesso.value = ''; estado.value = null;
    try {
      const { data } = await api.put(endpoint, payload);
      if (data?.boletos_operacionais !== desejado) throw new Error('Resposta incompleta');
      await consultar();
      if (estado.value !== desejado) throw new Error('Estado alterado durante a confirmação');
      sucesso.value = desejado ? 'Módulo de boletos ativado nesta escola.' : 'Módulo de boletos desativado nesta escola.';
    } catch (error) {
      estado.value = null; metadata.value = null;
      if (error?.response?.status === 409) {
        erro.value = 'O estado foi modificado por outro administrador. Os dados foram atualizados; revise e confirme novamente.';
        try { await consultar(); } catch { erro.value = 'O estado foi modificado por outro administrador. Não foi possível atualizar os dados; tente novamente.'; }
      } else if (error?.response?.status === 403) {
        erro.value = 'Alteração não autorizada. Verifique sua permissão e a identidade da escola antes de atualizar os dados.';
      } else {
        erro.value = 'Não foi possível confirmar a alteração. O resultado é desconhecido; atualize os dados antes de tentar novamente.';
      }
    } finally { fechar(); busy.value = false;
      if (typeof window !== 'undefined') window.dispatchEvent(new Event('boletos-capability-changed'));
    }
  }
  return { estado, busy, erro, sucesso, alvo, confirmacao, frase, podeConfirmar, carregar, solicitar, salvar, fechar };
}
